import { GenericDataType } from "src/modules/enaio/shared/GenericDataType";
import { Utils } from "src/modules/utils/shared/utils";

export class EnaioFrontendField {
    id = "";
    title = "";
    type: GenericDataType;
    defaultValue: any;

    getDefaultValueForForm(): any {
        return (this.type == GenericDataType.date || this.type == GenericDataType.dateTime) && Utils.isString(this.defaultValue) ? new Date(this.defaultValue as string) : this.defaultValue;
    }
}
